/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkUserAction } from './BulkUserAction';
import {
    BulkUserActionFromJSON,
    BulkUserActionFromJSONTyped,
    BulkUserActionToJSON,
    BulkUserActionToJSONTyped,
} from './BulkUserAction';

/**
 * 
 * @export
 * @interface BulkUserActionBody
 */
export interface BulkUserActionBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUserActionBody
     */
    userIds: Array<string>;
    /**
     * 
     * @type {BulkUserAction}
     * @memberof BulkUserActionBody
     */
    action: BulkUserAction;
}



/**
 * Check if a given object implements the BulkUserActionBody interface.
 */
export function instanceOfBulkUserActionBody(value: object): value is BulkUserActionBody {
    if (!('userIds' in value) || value['userIds'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function BulkUserActionBodyFromJSON(json: any): BulkUserActionBody {
    return BulkUserActionBodyFromJSONTyped(json, false);
}

export function BulkUserActionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUserActionBody {
    if (json == null) {
        return json;
    }
    return {
        
        'userIds': json['userIds'],
        'action': BulkUserActionFromJSON(json['action']),
    };
}

export function BulkUserActionBodyToJSON(json: any): BulkUserActionBody {
    return BulkUserActionBodyToJSONTyped(json, false);
}

export function BulkUserActionBodyToJSONTyped(value?: BulkUserActionBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userIds': value['userIds'],
        'action': BulkUserActionToJSON(value['action']),
    };
}

